const CandidateDetailsTab = {
    RECORD: 0,
    FILES: 1,
}

export default CandidateDetailsTab;